import React from 'react';
import {
  Typography, Select, MenuItem, Chip, Button, Divider, Stack, Box,
} from '@mui/material';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import FlagIcon from '@mui/icons-material/Flag';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import BlockIcon from '@mui/icons-material/Block';
import SectionCard from '../ui/SectionCard';
import {
  STATUS_LABELS, getSelectableStatuses, getStatusHex, getStatusChipSx,
} from '../../constants/status';

// dropdown เลือกสถานะได้อิสระ (ยกเว้น WON/LOST ที่ต้องกดผ่านปุ่ม "จบงาน" แยกต่างหาก
// เพราะมีเอกสาร PO/BOQ ต้องแนบ — ดู getSelectableStatuses) และยกเว้นสถานะปัจจุบัน
// เป็น action trigger ไม่ใช่ตัวแสดงค่าปัจจุบัน เลยรีเซ็ตเป็นค่าว่างตลอด แล้วให้ onSelect
// เปิด dialog ยืนยัน (note) เหมือนเดิม ไม่ได้เปลี่ยนสถานะทันทีที่เลือก
export function StatusActionsCard({
  currentStatus, isTender, onSelect, onFinishJob, onCreateProject, linkedProject, onOpenProject,
}) {
  const otherStatuses = getSelectableStatuses(isTender, currentStatus).filter((s) => s !== currentStatus);

  return (
    <SectionCard icon={<TrendingUpOutlinedIcon />} title="สถานะโครงการ" accentColor={getStatusHex(currentStatus)}>
      <Stack spacing={2}>
        <Box>
          <Chip
            label={STATUS_LABELS[currentStatus] || currentStatus}
            variant="filled"
            sx={{ fontWeight: 700, px: 1, ...getStatusChipSx(currentStatus, 'filled') }}
          />
        </Box>

        {currentStatus !== 'WON' && currentStatus !== 'LOST' && currentStatus !== 'CANCELLED' && (
          <>
            <Select
              size="small"
              fullWidth
              value=""
              displayEmpty
              onChange={(e) => onSelect(e.target.value)}
              renderValue={() => (
                <Typography variant="body2" color="text.secondary">เปลี่ยนสถานะเป็น...</Typography>
              )}
            >
              {otherStatuses.map((s) => (
                <MenuItem key={s} value={s}>
                  <Chip size="small" label={STATUS_LABELS[s]} variant="outlined" sx={getStatusChipSx(s, 'outlined')} />
                </MenuItem>
              ))}
            </Select>
            <Divider />
            <Button fullWidth variant="contained" color="success" startIcon={<FlagIcon />} onClick={onFinishJob} sx={{ borderRadius: 2 }}>
              จบงาน
            </Button>
            <Button fullWidth variant="outlined" color="error" startIcon={<BlockIcon />} onClick={() => onSelect('CANCELLED')} sx={{ borderRadius: 2 }}>
              ยกเลิกโครงการ
            </Button>
          </>
        )}

        {currentStatus === 'WON' && (
          <>
            <Divider />
            {linkedProject ? (
              // มี project_id ผูกไว้แล้ว (สร้างโครงการไปแล้ว) — โชว์สรุปโครงการแทนปุ่ม
              // กดได้เหมือนปุ่ม เปิด P111 project popup (ดู onOpenProject ใน OpportunityDetail.js)
              <Box
                onClick={onOpenProject}
                sx={{
                  p: 1.5, borderRadius: 2, bgcolor: 'secondary.main', display: 'flex',
                  alignItems: 'center', gap: 1.5, cursor: 'pointer',
                  transition: 'background-color 0.15s',
                  '&:hover': { bgcolor: 'secondary.dark' },
                }}
              >
                <BusinessCenterIcon sx={{ color: 'secondary.contrastText' }} />
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="caption" noWrap sx={{ display: 'block', color: 'secondary.contrastText', opacity: 0.85 }}>
                    ดูข้อมูล
                  </Typography>
                  <Typography variant="body2" fontWeight={700} noWrap sx={{ color: 'secondary.contrastText' }}>
                    {linkedProject.project_number} {linkedProject.name}
                  </Typography>
                  <Typography variant="caption" noWrap sx={{ display: 'block', color: 'secondary.contrastText', opacity: 0.85 }}>
                    {linkedProject.customer}
                  </Typography>
                </Box>
              </Box>
            ) : (
              // ใช้สี secondary (ส้ม) เป็น accent เดียวของโมดูล ตามหลัก 50/30/20 — สงวนไว้
              // ให้ action ที่สำคัญที่สุดของ flow นี้เท่านั้น (แปลงดีลที่ได้งานเป็นโครงการจริง)
              <Button fullWidth variant="contained" color="secondary" startIcon={<BusinessCenterIcon />} onClick={onCreateProject} sx={{ borderRadius: 2 }}>
                สร้างโครงการ
              </Button>
            )}
          </>
        )}
      </Stack>
    </SectionCard>
  );
}

export default StatusActionsCard;
